import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import withAddContactLogic from 'shared/hocs/withAddContactLogic';
import NewPassword from 'shared/components/NewPassword';
import ProfilePhoneInput from 'desktop/components/ProfilePhoneInput/ProfilePhoneInput';
import ModalContainer from 'shared/components/ModalContainer/ModalContainer';
import s from './Contacts.css';

class Contacts extends Component {
  static propTypes = {
    resendVerifyCode: PropTypes.func.isRequired,
    getVerifyCode: PropTypes.func.isRequired,
    verifyPhone: PropTypes.func.isRequired,
    serverError: PropTypes.string,
    values: PropTypes.shape().isRequired,
    touched: PropTypes.shape().isRequired,
    errors: PropTypes.shape().isRequired,
    handleChange: PropTypes.func.isRequired,
    handleBlur: PropTypes.func.isRequired,
    //
    onRemovePhone: PropTypes.func.isRequired,
    setPhoneOrder: PropTypes.func.isRequired,
    onClickAddPhone: PropTypes.func.isRequired,
    onDeletePhone: PropTypes.func.isRequired,
    removeError: PropTypes.func.isRequired,
    onSubmitEmail: PropTypes.func.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
    isSubmittingData: PropTypes.bool,
    isCarEdit: PropTypes.bool,
    //
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    serverError: '',
    isSubmittingData: false,
    isCarEdit: false,
  };

  state = {
    isModal: false,
    phoneToRemove: null,
    phonesWithSendCode: [],
  };

  handleRemovePhone = index => {
    this.props.onRemovePhone(index);
  };

  handleCloseModal = () => {
    this.setState({ isModal: false, phoneToRemove: null });
  };

  handleOpenPhoneModal = id => {
    this.setState({ isModal: true, phoneToRemove: id });
  };

  handleRemoveProfilePhone = () => {
    const { phoneToRemove: id } = this.state;
    this.props.onDeletePhone(id);
    this.setState({ isModal: false, phoneToRemove: null });
  };

  handleGetVerifyCode = number => {
    this.setState(({ phonesWithSendCode }) => ({
      phonesWithSendCode: [...phonesWithSendCode, number],
    }));
    this.props.getVerifyCode(number);
  };

  handleSubmitEmail = e => {
    e.preventDefault();

    const { values, onSubmitEmail } = this.props;
    if (values.email && values.email.length > 0) {
      onSubmitEmail(values.email);
    }
  };

  render() {
    const {
      values,
      touched,
      errors,
      handleChange,
      handleBlur,
      serverError,
      onClickAddPhone,
      resendVerifyCode,
      verifyPhone,
      setPhoneOrder,
      isSubmittingData,
    } = this.props;

    const { removeError, isSubmitting, intl, isCarEdit } = this.props;

    const { isModal, phonesWithSendCode } = this.state;

    return (
      <div className={s.root}>
        <div className={s.container}>
          <div className={s.title}>
            <FormattedMessage id="Редактировать контактные данные" />
          </div>
          <form className={s.form}>
            {!isCarEdit && (
              <div className={s.inputContainer}>
                <div className={s.label}>
                  <FormattedMessage id="Почта" />
                </div>
                <input
                  name="email"
                  type="text"
                  placeholder={intl.formatMessage({ id: 'Введите почтовый адрес' })}
                  className={cx(s.input, errors.email && touched.email && s.error)}
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {!errors.email && (
                  <button
                    disabled={isSubmittingData}
                    className={s.emailBtn}
                    onClick={this.handleSubmitEmail}
                  >
                    <FormattedMessage id="Сохранить" />
                  </button>
                )}
              </div>
            )}

            <div htmlFor="phone" className={s.label}>
              <FormattedMessage id="Телефоны" />
            </div>
            <div className={cx(s.inputContainer, s.phonesContainer)}>
              {values.phones.map(({ id, is_verified: isVerified, number }, i, phones) => {
                const isSendCode = phonesWithSendCode.includes(number);
                const order = isSendCode ? '1' : setPhoneOrder(isVerified);
                const canBeRemoved = (phones.filter(item => !!item.is_verified) || []).length > 1;

                return (
                  <div key={id || i} style={{ order }}>
                    <ProfilePhoneInput
                      resendVerifyCode={resendVerifyCode}
                      getVerifyCode={this.handleGetVerifyCode}
                      isSendCode={isSendCode}
                      verifyPhone={verifyPhone}
                      removeError={removeError}
                      isSubmitting={isSubmitting}
                      serverError={serverError}
                      isVerified={isVerified}
                      number={number}
                      index={i}
                      phoneId={id}
                      onRemovePhoneClick={this.handleRemovePhone}
                      onOpenModal={this.handleOpenPhoneModal}
                      isMobile
                      canBeRemoved={canBeRemoved}
                    />
                  </div>
                );
              })}

              <div className={cx(s.row, s.actions)}>
                <div className={cx(s.btn, s.send)} onClick={onClickAddPhone}>
                  <FormattedMessage id="Добавить телефон" />
                </div>
              </div>
            </div>
            {!isCarEdit && (
              <div className={s.label} style={{ marginBottom: '20px' }}>
                <FormattedMessage id="Пароль" />
              </div>
            )}
            {!isCarEdit && (
              <div className={s.root}>
                <NewPassword />
              </div>
            )}
          </form>
        </div>

        <ModalContainer modalCN={s.modal} onClose={this.handleCloseModal} isOpen={isModal}>
          <div className={s.modalTitle}>
            <FormattedMessage id="Вы уверены, что хотите удалить номер?" />
          </div>
          <div className={s.modalAnswers}>
            <span className={s.modalYes} onClick={this.handleRemoveProfilePhone}>
              <FormattedMessage id="Да" />
            </span>
            <span className={s.modalNo} onClick={this.handleCloseModal}>
              <FormattedMessage id="Нет" />
            </span>
          </div>
        </ModalContainer>
      </div>
    );
  }
}

export default withAddContactLogic(withStyles(s)(injectIntl(Contacts)));



// WEBPACK FOOTER //
// ./src/mobile/routes/personal/edit/components/Contacts/Contacts.js